import { formatToString } from '@/utils/libs/date-fns/format';
const DATE_FORMAT_TEXT = 'yyyy年MM月dd日';
const DATE_FORMAT_HAS_TIME = 'yyyy年MM月dd日 HH:mm';
const DATE_FORMAT_SUBMIT = 'yyyy-MM-dd HH:mm:ss';
const TIME_FORMAT_TEXT = 'HH:mm';
/**
 * 開始日時と時間から終了日時を取得する
 */
export const getToAt = (fromAt, time) => {
    const toAtDate = new Date(fromAt);
    const fromAtHour = toAtDate.getHours();
    toAtDate.setHours(fromAtHour + time);
    return toAtDate;
};
/**
 * 単体の日付表示用にフォーマットする
 */
export const formatDateToText = (date, hasTime) => formatToString({
    formatString: hasTime ? DATE_FORMAT_HAS_TIME : DATE_FORMAT_TEXT,
    value: date,
});
/**
 * 開始日時と終了日時を受け取り、確定した相談日の表示用にフォーマットする
 * @example 2024年10月01日 11:00~12:00
 */
export const formatDateToFixedTimeText = (fromAt, toAt) => `${formatToString({ formatString: DATE_FORMAT_HAS_TIME, value: new Date(fromAt) })}〜${formatToString({ formatString: TIME_FORMAT_TEXT, value: new Date(toAt) })}`;
/**
 * 相談希望日の表示用にフォーマットする
 * @example 2024年09月24日〜2024年09月27日
 */
export const formatDateToRangeText = (fromAt, toAt) => `${formatToString({ formatString: DATE_FORMAT_TEXT, value: new Date(fromAt) })}〜${formatToString({ formatString: DATE_FORMAT_TEXT, value: new Date(toAt) })}`;
/**
 * 相談日程を送信用のフォーマットに変換する
 * @example 2024-09-24 11:00:00
 */
export const formatDateToSubmitValue = (date) => formatToString({
    formatString: DATE_FORMAT_SUBMIT,
    value: date,
});
